import type { Option } from "types";
import { useForm as useFormHook } from "hooks";
import { BooleanSwitchValue, MOR } from "consts/general";
import { PaymentProduct } from "consts/openBanking";
import { parse } from "util/parsers";
import { find, when } from "util/support";
import type { BankingSdkConnectorsRecipientsPivot } from "features/openBanking/types";
import {
    FormField,
    type BankingSDKConnectorsRecipientsPivotForm,
    type BankingSDKConnectorsRecipientsPivot,
    type BootstrapData
} from "./types";
import useValidationSchema from "./useValidationSchema";

export const getInitialValues = ({
    paymentProduct,
    regReportingCodes,
    ...restInitialValues
}: Partial<BankingSdkConnectorsRecipientsPivot> = {}, bootstrapData: BootstrapData): BankingSDKConnectorsRecipientsPivot => {
    const paymentProducts = find<Option>(bootstrapData.PaymentProducts, 'id');

    return {
        [FormField.RegReportingCodes]: parse(`${regReportingCodes}`, null),
        [FormField.IsEnabled]: BooleanSwitchValue.Off,
        [FormField.BankId]: BooleanSwitchValue.Off,
        [FormField.RecipientId]: BooleanSwitchValue.Off,
        [FormField.Mor]: MOR.Default,
        [FormField.PaymentProduct]: when(
            paymentProduct,
            () => paymentProducts(Number(paymentProduct)),
            () => paymentProducts(PaymentProduct.Domestic)
        ),
        ...restInitialValues
    };
};

export const useForm = (bankingSDKConnectorsRecipientsPivotForm: BankingSDKConnectorsRecipientsPivotForm) =>
    useFormHook({
        enableReinitialize: true,
        ...bankingSDKConnectorsRecipientsPivotForm,
        validateOnMount: true,
        validationSchema: useValidationSchema()
    });
